export const total = {
  primary: 'hsla(211, 100%, 50%, 1)',
  500: 'hsla(211, 100%, 68%, 1)',
  400: 'hsla(211, 100%, 74%, 1)',
  300: 'hsla(211, 100%, 80%, 1)',
  200: 'hsla(211, 100%, 86%, 1)',
  100: 'hsla(211, 100%, 90%, 1)',
  50: 'hsla(211, 100%, 94%, 1)',
  30: 'hsla(211, 100%, 94%, 0.5)',
};
